import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import PageHeader from '../../../shared/PageHeader';
import '../../../shared/ListRowHover.css';
import './UomControlTypeUsagePage.css';
import { formatNumber } from '../../../shared/numberFormat';

// Drill-down behind the "In Use" count on the UoM Control Types list —
// every Product UoM row across the tenant currently assigned this Control
// Type, reached via GET /api/uom-control-types/:id/product-uoms.
function UomControlTypeUsagePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios.get(`/api/uom-control-types/${id}/product-uoms`)
      .then((res) => setData(res.data.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [id]);

  const controlType = data?.uom_control_type;
  const rows = data?.rows || [];

  return (
    <div className="uom-control-type-usage-page" style={{ width: '100%', maxWidth: 1000, margin: '32px auto 48px', background: '#f6f8fa', borderRadius: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', padding: '20px 32px 32px 24px' }}>
      <PageHeader
        crumbs={[
          { label: 'UoM Control Types', onClick: () => navigate('/inventory-uom-control-types') },
          { label: controlType ? `${controlType.code} — ${controlType.name}` : 'In Use' },
        ]}
        title={controlType ? `In Use: ${controlType.name}` : 'In Use'}
        subtitle={`${rows.length} Product UoM row${rows.length === 1 ? '' : 's'} assigned this Control Type`}
      />

      <div style={{ marginTop: 16, borderRadius: 10, overflow: 'auto', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
        <table style={{ width: '100%', minWidth: 760, borderCollapse: 'collapse', fontSize: 15, tableLayout: 'fixed' }}>
          <colgroup>
            <col style={{ width: '12%' }} />
            <col style={{ width: '52%' }} />
            <col style={{ width: '9%' }} />
            <col style={{ width: '9%' }} />
            <col style={{ width: '6%' }} />
            <col style={{ width: '6%' }} />
            <col style={{ width: '6%' }} />
          </colgroup>
          <thead className="list-head" style={{ fontSize: 14 }}>
            <tr>
              <th style={{ padding: '12px 8px', fontWeight: 600, borderBottom: '1px solid #b3bbc7', textAlign: 'left' }}>SKU</th>
              <th style={{ padding: '12px 8px', fontWeight: 600, borderBottom: '1px solid #b3bbc7', textAlign: 'left' }}>Product</th>
              <th style={{ padding: '12px 8px', fontWeight: 600, borderBottom: '1px solid #b3bbc7', textAlign: 'right' }}>UoM</th>
              <th style={{ padding: '12px 8px', fontWeight: 600, borderBottom: '1px solid #b3bbc7', textAlign: 'center' }}>Conv. Rate</th>
              <th style={{ padding: '12px 8px', fontWeight: 600, borderBottom: '1px solid #b3bbc7', textAlign: 'center' }}>Buy</th>
              <th style={{ padding: '12px 8px', fontWeight: 600, borderBottom: '1px solid #b3bbc7', textAlign: 'center' }}>Sell</th>
              <th style={{ padding: '12px 8px', fontWeight: 600, borderBottom: '1px solid #b3bbc7', textAlign: 'center' }}>Track</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} style={{ padding: '14px', textAlign: 'center', background: '#f6f8fa', fontSize: 14 }}>Loading...</td></tr>
            ) : rows.length === 0 ? (
              <tr><td colSpan={7} style={{ padding: '14px', textAlign: 'center', background: '#f6f8fa', fontSize: 14 }}>No Product UoM rows use this Control Type</td></tr>
            ) : rows.map((row) => (
              <tr key={row.id} className="list-row">
                <td style={{ padding: '6px 8px', fontSize: 14, fontWeight: 600 }}>{row.product?.sku}</td>
                <td style={{ padding: '6px 8px', fontSize: 14, textAlign: 'left' }}>
                  {row.product ? (
                    <button
                      type="button"
                      className="link-button"
                      onClick={() => navigate(`/products/${row.product.id}/uom`)}
                    >
                      {row.product.name}
                    </button>
                  ) : '—'}
                </td>
                <td style={{ padding: '6px 8px', fontSize: 14, textAlign: 'right' }} title={row.uom?.name || ''}>{row.uom?.code || '—'}</td>
                <td style={{ padding: '6px 8px', textAlign: 'center', fontSize: 14 }}>{formatNumber(row.conversion_rate, { maxDecimals: 4 })}</td>
                <td style={{ padding: '6px 8px', textAlign: 'center', fontSize: 14 }}>{row.can_buy ? '✓' : '–'}</td>
                <td style={{ padding: '6px 8px', textAlign: 'center', fontSize: 14 }}>{row.can_sell ? '✓' : '–'}</td>
                <td style={{ padding: '6px 8px', textAlign: 'center', fontSize: 14 }}>{row.can_track ? '✓' : '–'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default UomControlTypeUsagePage;
